export const PBL_TIMEZONE = 'Asia/Hong_Kong';
export const PBL_UTC_OFFSET = '+08:00';

const hasExplicitTimezone = (value: string) => /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);

export const toHongKongCalendarDateTime = (value?: string | null) => {
  const normalizedValue = value?.trim().replace(' ', 'T');
  if (!normalizedValue || !hasExplicitTimezone(normalizedValue)) return normalizedValue;

  const date = new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) return normalizedValue;

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: PBL_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  })
    .formatToParts(date)
    .reduce<Record<string, string>>((result, part) => {
      if (part.type !== 'literal') result[part.type] = part.value;
      return result;
    }, {});

  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
};

export const toHongKongMeetingDisplayDateTime = (value?: string | null, display?: string | null) => {
  if (display && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(display)) return display;
  if (!value || !hasExplicitTimezone(value.trim())) return null;
  return toHongKongCalendarDateTime(value);
};

export const toHongKongApiDateTime = (date: string, time: string) => `${date}T${time}:00${PBL_UTC_OFFSET}`;

export const formatPblDisplayDate = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') return '-';

  const rawValue = String(value).trim();
  if (!rawValue) return '-';

  const datePrefix = rawValue.match(/^(\d{4}[-/]\d{1,2}[-/]\d{1,2})(?:T|\s)/);
  if (datePrefix) return datePrefix[1];

  return rawValue;
};
